module.exports = __webpack_public_path__ + "static/img/far2_active.f91dbd25.png";